import api from './../helpers/api'


class PurchaseService{ 

    save_to_cart(product_id,wharehouse,quantity,id,cPrice,upsell_price){
        return api.post(`/save_purchase_to_cart/${id}`,{
            product_id,quantity,wharehouse,cPrice,upsell_price
        }, );
    }

    get_purchase_items(id){
        return api.post(`/get_purchase/${id}`, );
    }

    get_purchases(){
        return api.get(`/get_purchases`, );
    }

    get_purchase(id){
        return api.post(`/purchase/${id}`, );
    }

    //delete product from cart
    deletep(id,product_id){
        return api.post(`/delete_item_purchased/${id}`,{
            product_id
        }, );
    }

    //clear purchas cart
    clear_purchase_cart(id){
        return api.post(`/clear_purchase_cart/${id}`, );
    }

    //saving purchase
    save_purchase(cart,supplier,balance,cart_total,charges = [],charges_in_cost = false){
        return api.post(`/save_purchase`,{
          cart,supplier_id:supplier.id,amount:supplier.amount,balance,cart_total,
          charges,charges_in_cost
        },);
    }

    //show product for sale

    show_for_sale(id){
        return api.post(`/show_for_purchase/${id}`,{},);
    }

    //from are the purchase reports
    //getting all purchases

    get_purchase_report(range){
        console.log(range);
        
        return api.post(`/get_purchase_report`,{range}).then(
            response => {
                return response.data
            }
        );
    }

    //pay purchase balance
    save_purchase_balance(id,remain,amount){
        return api.post(`/save_purchase_balance/${id}`,{
            remain,amount
        },);
    }

    //get purchases
    get_purchase_product(id){
        return api.get(`/get_purchase_product/${id}`, );
    }

    //get monthly purchases 
    
    get_monthly_purchase(month){
        return api.post(`/get_monthly_purchase`,{month},);
    }
}

export default new PurchaseService